<script setup>
    import {computed} from "vue";
    import {Method} from "@inertiajs/inertia";

    const props = defineProps({
        type: {
            type: String,
            default: 'submit',
        },

        method: {
            type: String,
            default: Method.GET
        },

        link: {
            type: String,
            default: ''
        }
    });

    const bType = computed(() => {
        if(props.type === 'link') { return 'button'; }

        return props.type;
    });
</script>

<template>
    <button
        :type="bType"
        class="button"
        @click="() => {
            if(type === 'link') {
                $inertia.visit(link, {
                    method: method
                })
            }
        }"
    >
        <slot />
    </button>
</template>
